module.exports = __webpack_public_path__ + "static/img/product_financial.acd30fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/product_financial.png
// module id = fKDt
// module chunks = 0